import { useEffect } from "react";
import Plyr from "plyr";
import "plyr/dist/plyr.css";

export default function usePlyr(containerRef, deps = []) {
  useEffect(() => {
    const container = containerRef?.current;
    if (!container) return;

    container.querySelectorAll("video.js-plyr").forEach(video => {
      if (video.__plyr) {
        video.__plyr.destroy();
        delete video.__plyr;
      }
    });

    const players = [];
    const videos = container.querySelectorAll("video.js-plyr");

    videos.forEach(video => {
      const player = new Plyr(video, {
        controls: [
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "settings",     // enables speed menu
          "pip",          // picture-in-picture button
          "fullscreen",
        ],
        settings: ["speed"],  // show only speed (add "quality" later if needed)
        speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 2] },
        fullscreen: { enabled: true, fallback: true },
      });

      video.__plyr = player;
      players.push(player);
    });

    return () => {
      players.forEach(p => p.destroy());
      videos.forEach(v => delete v.__plyr);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
